import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/StrategicConsulting/132314.jpg"
import { FaCog, FaCompass, FaDatabase, FaPaintBrush, FaRegSmile, FaUserAlt } from "react-icons/fa"
import {MdTranslate} from "react-icons/md"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Maturity Assessment
            </h1>
            <p className="text-lg text-gray-600">
              Maturity Assessment: Evaluate the maturity of your data infrastructure, governance, and analytics processes.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaCog className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Analytics Process Maturity</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Analyze the sophistication of your data analysis, reporting, and decision-making workflows.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaDatabase className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Data Infrastructure Maturity</h3>         
              </div>
              <p className="text-gray-600 text-sm">
              Assess the readiness and scalability of your data storage, processing, and integration systems.
              </p>
            </div>

            {/* Feature 3 */}
            {/* <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaPaintBrush className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Aesthetic Appeal</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Create visually appealing interfaces that align with brand identity.
              </p>
            </div> */}

          </div>
        </div>

      
      </div>
    </div>
  )
}